import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApiFunction from "../../api/useApiFunction";
import valueContext from "../../customHook/useContext";

function Downline() {
  const { joinMemberToken } = useContext(valueContext);
  const token = joinMemberToken();
  const [data, setData] = useState("");
  const { formDataFunc } = useApiFunction();
  const navigate = useNavigate();
  async function getDownline() {
    const res = await formDataFunc(
      "member/get_downline",
      JSON.stringify({}),
      "POST",
      token
    );
    if (res.status) {
      setData(res.msg);
    } else if (
      res.error &&
      (res.error === "ERROR_TOKEN_INVALID0" ||
        res.error === "ERROR_TOKEN_INVALID1" ||
        res.error === "user not registered" ||
        res.error === "ERROR_TOKEN_INVALID2" ||
        res.error === "ERROR_TOKEN_INVALID3" ||
        res.error === "unauthorized" ||
        res.error === "Your session has expierd Please login again 1" ||
        res.error === "Your session has expierd Please login again 2")
    ) {
      navigate("/login");
    } else if (res.error) {
      toast.warning(res.error, { autoClose: 2000 });
    } else {
      toast.warning(res.msg, {
        autoClose: 2000
      });
    }
  }
  useEffect(() => {
    getDownline();
  }, []);
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">Downline</h4>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <h4 className="card-title table-head">Downline List</h4>

                    <div className="table-responsive table-line">
                      <table
                        className="table align-middle mb-0"
                        id="order-listing"
                      >
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>userName</th>
                            <th>email</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data && data.length > 0 ? (
                            data.map((details, i) => {
                              return (
                                <tr>
                                  <th scope="row">{i + 1}</th>
                                  <td>
                                    {details.memberDetails.length > 0
                                      ? details.memberDetails[0].name
                                      : "-"}
                                  </td>
                                  <td>
                                  {details.memberDetails.length > 0
                                      ? details.memberDetails[0].userName
                                      : "-"}
                                  </td>
                                  <td>
                                  {details.memberDetails.length > 0
                                      ? details.memberDetails[0].email
                                      : "-"} 
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <p>NO DATA</p>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Downline;
